/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensalidadesAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD_MENSALIDADES = 'custom-card-mensalidades',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK = 'deck',
  FETCH_MENSALIDADES = 'fetch-mensalidades',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_NOTA_FISCAL = 'field-nota-fiscal',
  FIELD_TOTAL = 'field-total',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  LAYOUT_MENSALIDADES = 'layout-mensalidades',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_MENSALIDADE_TOTAL = 'text-mensalidade-total',
}
export { MensalidadesAliases };
